"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._IndexDocument = {
    type: "structure",
    required: ["Suffix"],
    members: {
        Suffix: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_IndexDocument.js.map